import { render, staticRenderFns } from "./AssetPage.vue?vue&type=template&id=0c91a8d4&scoped=true"
import script from "./AssetPage.vue?vue&type=script&lang=js"
export * from "./AssetPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c91a8d4",
  null
  
)

export default component.exports